<template>
    <div class="group-item-selector">

        <div class="group-col">
            <div class="header">
                {{ labelGroup }}
            </div>
            <component :class="{active:group.id == currentGroupId}"
                       :key="group.id"
                       :is="rendererGroup"
                       :nbSelectedItems="getNbSelectedItems(group.id)"
                       @click.native="fetchItems(group.id)"
                       @selected="handleGroupSelected"
                       v-bind="{group:group}"
                       v-for="group in groups"
            ></component>
        </div>

        <div class="item-col">
            <div :class="{hasSelection:currentGroupId}" class="header">
                {{ labelItem }}
            </div>
            <div :class="{empty:!currentGroupId}" class="items-container">
                <component :is="rendererItem"
                           :key="item.id"
                           @selected="handleItemSelected"
                           v-bind="{item:item}"
                           v-for="item in groupItems"
                ></component>
                <LoadingLight id="itemsLoading"></LoadingLight>
            </div>
        </div>

    </div>
</template>

<script>
    //import Component from 'path/to/component'
    import {mapGetters, mapMutations} from 'vuex'
    import axios from 'axios'
    import API from '@s/API'
    import Vue from 'vue'
    import _find from 'lodash/find'

    import VehicleGroup from '@c/plugins/formbuilder/renderers/groupItem/VehicleGroup'
    import VehicleItem from '@c/plugins/formbuilder/renderers/groupItem/VehicleItem'

    import LoadingLight from '@c/ui/LoadingLight'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            VehicleGroup,
            VehicleItem,
            LoadingLight
        },
        computed: {

            ...mapGetters({
                currentStepData: 'Plugins/currentStepData'
            }),

            groupItems() {
                if (this.currentGroupId !== null) {
                    return this.items[this.currentGroupId]
                }
                return []
            }


        },
        created: function () {

        },
        data() {
            return {
                groups: [],
                items: {},
                currentGroupId: null
            }
        },
        destroyed: function () {

        },
        methods: {
            ...mapMutations({
                showLoadingLight: 'UI/showLoadingLight',
            }),
            fetchGroups() {
                axios.get(API.route(this.apiRouteGroup) + API.constructQueryParams({perpage: 999999}))
                    .then(response => {

                        console.warn('FETCH-GROUP',this.value.groups)

                        this.groups = response.data.data
                        this.groups.map(item => {
                            Vue.set(item, 'selected', false)
                            if(this.value.groups.indexOf(item.id) !== -1) {
                                Vue.set(item, 'selected', true)
                            }
                            Vue.set(this.items, '' + item.id, [])

                        })
                        //this.showLoading(false)
                    })
            },
            fetchItems(groupId) {
                if (this.currentGroupId == groupId) {
                    this.currentGroupId = null
                    //this.items = []
                } else {

                    if (this.items[groupId].length > 0) {
                        this.showLoadingLight({id: 'itemsLoading', show: true})
                        setTimeout(() => {
                            this.currentGroupId = groupId
                            this.showLoadingLight({id: 'itemsLoading', show: false})
                        }, 500)
                    } else {
                        this.currentGroupId = groupId
                        this.showLoadingLight({id: 'itemsLoading', show: true})
                        axios.get(API.route(this.apiRouteItem, {groupId: groupId}) + API.constructQueryParams({perpage: 999999}))
                            .then(response => {
                                this.items[this.currentGroupId] = response.data.data

                                this.items[this.currentGroupId].map(item => {
                                    if (this.value.items.indexOf(item.id) !== -1) {
                                        Vue.set(item, 'selected', true)
                                    }
                                })

                                let group = _find(this.groups, {id: groupId})

                                if (group.selected === true) {
                                    this.items[this.currentGroupId].map(item => {
                                        Vue.set(item, 'selected', true)
                                    })

                                }
                                this.showLoadingLight({id: 'itemsLoading', show: false})
                                //this.showLoading(false)
                            })
                    }


                }
            },

            handleGroupSelected(item, selected) {

                item.selected = selected

                /*this.handleSelected('groups', item, selected)*/
                if (item.id == this.currentGroupId) {
                    this.items[item.id].map(item => {
                        Vue.set(item, 'selected', selected)
                    })
                }

                this.constructGroups(this.groups)
                this.constructItems(this.items)

                this.fetchItems(item.id)
            },

            handleItemSelected(item, selected) {

                Vue.set(item, 'selected', selected)

                if (selected === false) {
                    let group = _find(this.groups, {id: item.groupId})
                    group.selected = false
                }

                this.constructItems(this.items)


            },

            getNbSelectedItems(groupId){
                if(this.items[groupId]) {
                    return this.items[groupId].filter(item => {
                        return item.selected === true
                    }).length
                }
                return 0
            },

            constructGroups(newVal){
                this.value.groups = []

                let selected = newVal.filter(group => {
                    return group.selected === true
                })

                selected.forEach(group => {
                    this.value.groups.push(group.id)
                })
            },

            constructItems(newVal){
                this.value.items = []
                let keys = Object.keys(newVal)
                keys.forEach(groupKey => {
                    let groupIsSelected = this.value.groups.indexOf(parseInt(groupKey)) !== -1
                    console.log(this.value.groups,groupKey,groupIsSelected)
                    if (!groupIsSelected && newVal[groupKey].length > 0) {
                        let selected = newVal[groupKey].filter(item => {
                            return item.selected === true
                        })

                        selected.forEach(item => {
                            this.value.items.push(item.id)
                        })

                    }
                })
            }
        },
        mounted: function () {
            Vue.set(this.value, 'groups', [])
            Vue.set(this.value, 'items', [])
            this.fetchGroups()
        },
        name: 'GroupItemSelector',
        props: {
            rendererGroup: {
                type: String,
                default: null
            },
            apiRouteGroup: {
                type: String,
                required: true
            },
            labelGroup: {
                type: String,
                default: "Groupe"
            },
            rendererItem: {
                type: String,
                default: null
            },
            apiRouteItem: {
                type: String,
                required: true
            },
            labelItem: {
                type: String,
                default: "Elément"
            },

            value: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        updated: function () {

        },
        watch: {
            value(newVal){
                if(newVal.groups) {
                    this.groups.map(item => {
                        Vue.set(item, 'selected', false)
                        if (newVal.groups.indexOf(item.id) !== -1) {
                            Vue.set(item, 'selected', true)
                        }
                        Vue.set(this.items, '' + item.id, [])

                    })
                }
            }
            /*groups: {
                deep: true,
                handler(newVal) {
                    this.constructGroups(newVal)
                    this.constructItems(this.items)
                }
            },
            items: {
                deep: true,
                handler(newVal) {
                    this.constructItems(newVal)

                }
            }*/
        }
    }
</script>

<style lang="scss">
    .group-item-selector {
        display: flex;
        border: solid $form-elements-border-size $secondary-color;

        .header {
            background-color: $main-color;
            color: $main-white;
            font-weight: $bold;
            text-align: center;
            height: $table-head-height;
            line-height: $table-head-height;
            border-left: solid 0px lighten($main-color, 25%);

            &.hasSelection {
                border-left: solid 10px lighten($main-color, 25%);
                padding-right: 10px;
            }

        }

        /*.group-col, .item-col {
            flex: 0 0 50%;
        }*/

        .group-col {
            flex: 0 0 35%;
            //border-right: solid ($form-elements-border-size * 1.5) $secondary-color;

            .header {
                border-right: solid ($form-elements-border-size * 1.5) $secondary-color;
            }
        }

        .item-col {
            flex: 0 0 65%;

            .header {
                //background-color: lighten($main-color,25%);
            }
        }

        .items-container {
            background-color: #EEEEEE;
            height: calc(100% - #{$table-head-height});
            position: relative;
            border-left: solid 10px lighten($main-color, 25%);

            &.empty {
                border-left: solid 0px lighten($main-color, 25%);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/plugins/formbuilder/elements/GroupItemSelector.vue